module.exports = __webpack_public_path__ + "static/media/web-application.b1554b12.png";